import { render, staticRenderFns } from "./CustomFieldPriorityDisplay.vue?vue&type=template&id=6360f4a2"
import script from "./CustomFieldPriorityDisplay.vue?vue&type=script&lang=ts"
export * from "./CustomFieldPriorityDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports